// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__5cY5u","appear":"Loading_appear__IBO0R"};